import { Flex } from 'antd';
import CardDetailButton from '../cardDetailButton/cardDetailButton';
import InteractiveCard from '../common/interactiveCard';
import CardData from '../dashboard/cardData';
import FavouriteStatus from '../favouriteStatus/favouriteStatus';
import { Divider } from '../Ant';
import { useTranslation } from 'react-i18next';
import { Briefcase, Calendar, ShieldTick } from '../icons';

import { IMatter } from '../../interface/matter';
import { formatter, getMatterIconClass, getMatterLabel } from '../../constants/utilityFunctions';
import { ROUTES } from '../../constants/constants';
import { useNavigationStack } from '../../context/NavigationStackContext';
import NoteIcons from '../common/NoteIcons';
import { MatterStatus } from '../../constants/matter';
import { BorderColor, TagColor } from '../../interface/common';
import { MatterIndicators } from './matterIndicators';
import { InvoiceableType } from '../../constants/transaction';

const MatterCard = ({ matter }: { matter: IMatter }) => {
  const { t } = useTranslation();
  const { push } = useNavigationStack();

  const handleMatterDetail = () => {
    push(`${ROUTES.MATTER_DETAIL}/${matter?.id}`);
  };

  return (
    <InteractiveCard
      data-testid="matter-card"
      className={`pointer w-full conflict-card ${matter?.status === MatterStatus.ACTIVE ? BorderColor.GREEN : BorderColor.RED}`}
      onActivate={handleMatterDetail}
    >
      <Flex justify="space-between" align="center" className="pb-10">
        <Flex gap={5} align="center">
          <Flex
            data-testid="matter-card-status-chip"
            justify="center"
            align="center"
            className={`status-chip ${matter?.status === MatterStatus.ACTIVE ? TagColor.GREEN : TagColor.RED}`}
          >
            {t('matter:status.' + matter?.status)}
          </Flex>
          <Flex align="center" gap={5}>
            <NoteIcons
              hasImportantNotes={matter?.hasImportantNotes}
              hasImportantRelatedNotes={matter?.hasImportantRelatedNotes}
              hasNotes={matter?.hasNotes}
            />
            <MatterIndicators
              invoiceableType={matter?.invoiceableType as InvoiceableType}
              hasSubMatters={Boolean(matter?.hasSubMatters)}
              parentMatterId={matter?.parentMatterId}
              fixedPriceInUse={matter?.fixedPriceInUse}
              insider={matter?.insider}
              fixedPrice={matter?.fixedPrice}
              currency={matter?.currency}
            />
          </Flex>
        </Flex>
        <Flex gap={10} align="center">
          <FavouriteStatus
            isFavourite={matter?.isFavorite}
            testId="matter-card-favorite"
            tooltip={t('common:favorites')}
          />
          <CardDetailButton onOpen={handleMatterDetail} testId="matter-card-go-detail" />
        </Flex>
      </Flex>
      <Divider className="mb-10" />
      <Flex vertical gap={10}>
        <CardData
          type="matter"
          icon={<Briefcase className={getMatterIconClass(matter?.invoiceableType ?? '')} />}
          title={getMatterLabel(t, matter?.invoiceableType)}
          content={
            matter?.principalCompany?.name ?? matter?.principalPrivatePerson?.fullName ?? '-'
          }
          subcontent={matter?.matterNumber && `${matter?.matterNumber} - ${matter?.subject}`}
          contentclass="lineclamp-1"
          subcontentclass="lineclamp-1"
        />
        <Flex>
          <CardData
            icon={<ShieldTick />}
            type="responsible-person"
            title={t('matter:responsiblePerson')}
            content={matter?.responsibleUser?.fullName}
          />
          <CardData
            icon={<Calendar />}
            type="openingDate"
            title={t('matter:openingDate')}
            content={
              matter?.openingDate ? formatter.dateStandard(new Date(matter?.openingDate)) : '-'
            }
          />
        </Flex>
      </Flex>
    </InteractiveCard>
  );
};

export default MatterCard;
